import { Typography } from './Typography';
import styles from './PageIntro.module.css';
export function PageIntro({
  eyebrow,
  title,
  description,
}: {
  eyebrow: string;
  title: string;
  description: string;
}) {
  return (
    <section className={styles.intro}>
      <Typography variant="eyebrow" tone="muted">
        {eyebrow}
      </Typography>
      <Typography as="h1" variant="hero">
        {title}
      </Typography>
      <Typography tone="muted">{description}</Typography>
    </section>
  );
}
